export default "__VITE_ASSET__CqmqztZ0__"